export default {
	title: '{{brandName}}',
	description:
		'Check the <link>Getting Started guide</link> file for how to get your {{brandName}} project off the ground!',
	gettingStartedLink: 'Getting Started guide',
	courses: '{{mainEntityLabelPlural}}',
	nav: {
		signIn: 'Login',
		getStarted: 'Start free',
		home: 'Home',
		learn: 'Learn',
		catalog: 'Catalog',
		pricing: 'Pricing',
		viewFullCatalog: 'View full catalog',
		searchPlaceholder: 'What do you want to learn?',
		blog: 'Blog',
		about: 'About',
		contact: 'Contact',
		legal: 'Legal',
		help: 'Help',
	},
	pricing: {
		checkoutError: {
			title: 'We could not start the payment',
			body: 'The connection to the payment gateway failed. Try again in a few seconds; you have not been charged.',
			dismiss: 'Dismiss',
		},
	},
	legal: {
		index: {
			title: 'Legal information',
			description:
				'Review the terms, privacy, and cookie conditions applicable to {{brandName}}.',
			trustCenter: 'Trust Center',
			lastUpdatedLabel: 'Last updated',
			launchReadiness: 'Launch-ready version',
			openDocument: 'Open document',
			availableDocuments: 'Available documents',
		},
		links: {
			terms: { title: 'Terms' },
			privacy: { title: 'Privacy' },
			cookies: { title: 'Cookies' },
		},
		sectionLinkLabel: 'Link to this section',
		documentScope: {
			brand: 'Brand-specific document',
		},
	},
	footer: {
		title: 'Footer',
		tagline:
			'Empowering you to build your knowledge with {{brandName}}, gradually and joyfully',
		exploreCategories: 'Explore the most popular topics',
		noCategories: 'Categories will be available soon.',
		freeBadge: 'Free',
		viewAllCollections: 'View all {{collectionEntityLabelPluralLower}}',
		sections: {
			categories: 'Categories',
			categoryRoutes: 'Routes by category',
			legal: 'Legal',
			more: 'More',
		},
		copyright: '© {{year}} {{brandName}}. All rights reserved.',
	},
	social: {
		twitter: 'Twitter',
		email: 'Email',
	},
	home: {
		title: 'Welcome',
		description:
			'This is a demo application showing how to use i18n with react router 7.',
		getStarted: 'Start free',
	},
	about: {
		title: 'About',
		description:
			'This application demonstrates the integration of internationalization with react router 7.',
	},
}
